const ContractEndTypeEnum = {
  AMOUNT: "AMOUNT",
  DATEPERIOD: "DATEPERIOD",
} as const;

export default ContractEndTypeEnum;
